import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase";

/**
 * Logs a custom error event to Firebase Analytics.
 * @param {string} errorType - Type of error (e.g., "app_error", "react_error").
 * @param {string} message - Error message.
 * @param {object} details - Additional error details.
 */
export const logErrorToFirebase = (errorType, message, details = {}) => {
    logEvent(analytics, errorType, {
        message,
        ...details,
    });
};
